import { createPosition } from "@shared/common/utils/create";
import shortUUID from "short-uuid";
import type { IFormNPSNode, PartialNode } from "../type";

const createFormNPSNode = (data?: PartialNode<IFormNPSNode>): IFormNPSNode => {
  return {
    type: "FORM_NPS",
    id: shortUUID.generate(),
    pluginData: {
      contentEditorPropSeq: 0,
      contentMeta: [],
    },
    reactions: [],
    position: createPosition(data?.position),

    name: "",

    width: { value: 100, unit: "%" },

    fills: [],

    locked: false,

    strokes: [],
    strokeWeight: 1,
    strokeAlign: "CENTER",
    strokeCap: "SQUARE",
    strokeJoin: "ROUND",
    dashPattern: [],

    visible: true,

    effects: [],

    label: "<p>새 항목</p>",
    required: true,
    min: 0,
    range: 11,
    description: { left: "추천하고 싶지 않다", right: "추천하고 싶다" },

    ...data,
  };
};

export default createFormNPSNode;
